import {Component, Vue} from 'vue-property-decorator'
import {UserModule} from '@/store/modules/user'
import {gettHeaderByType, settHeaderByType} from '@/api/common'
import {
    getFinanceContractList,
    getDepartmentByLevel,
    financeArchiveExportData,
    delFinanceContractById, setFinanceContractStatus, financeContractExportData
} from '@/api/financial-center'
import {formatDate} from '@/utils/timeFilter'
import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from "@/utils";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";


@Component({
    components:{
        MoreUsersFilter
    }
})
export default class Contract extends Vue {
    // data
    tableHeadPopoverShow = false
    tableHeader: { filds: string; cnFilds: string; isShow: boolean; id: number }[] = []
    tableHead: any[] = []
    tableData = []
    page = 1
    limit = 20
    total = 0
    tableHeadFilter = {
        code: '',
        directorUserIdList: [],
        status: '',
        fileTypes: '',
        company: '',
        mainPart: '',
        mainPartName: '',
        createdUserIdList: [],
        types:'' ,// 学生合同or 代理合同  2024-5-9 改成了 小程序 / E签宝
        signStatus: '',
        remark:'',
    }
    tableCheckedData = []
    departmentList = []
    dialogShow = false
    receiverUser = '' // 修改后的负责人
    tableKey = Math.random()
    loading = false
    exportButtonDisabled = false
    exportHeaderDialogVisible = false

    newType = '1' //
    reviewId = ''
    action = ''
    cancelApproveDialog = false
    delOrderId = null
    delOrderDialogShow = false
    menuBtn = menuBtn
    filter_createdStartAt: Date[] = []
    filter_createdEndAt: Date[] = []
    timer = null
    // isReadonly = false
    draggableList = []
    draggableListChange = []
    dialogVisible = false

    get createdAt() {
        let str = ''
        if (this.filter_createdStartAt && this.filter_createdStartAt.length > 0) {
            str = formatDate('yyyy-MM-dd', new Date(this.filter_createdStartAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.filter_createdStartAt[1]))
        }
        return str
    }

    get endAt() {
        let str = ''
        if (this.filter_createdEndAt && this.filter_createdEndAt.length > 0) {
            str = formatDate('yyyy-MM-dd', new Date(this.filter_createdEndAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.filter_createdEndAt[1]))
        }
        return str
    }

    // computed


    // created
    created() {
        this.gettHeaderByType()
    }

    openDtatisticsData() { //统计报表
        window.open(window.location.origin + this.$route.matched[0].path + '/statisticalReport', '_blank')
    }

    handleLevalPersonl(val) {
        this.getDepartmentByLevel(val)
    }

    // 等级人员列表
    async getDepartmentByLevel(level) {
        const data: any = await getDepartmentByLevel(level)
        this.departmentList = data.departmentList
    }

    // 列表
    async getTableData() {
        this.loading = true

        const obj = {
            limit: this.limit,  //条数/页
            page: this.page, //页码
            code: this.tableHeadFilter.code,
            status: this.tableHeadFilter.status,
            directorUserIdList: this.tableHeadFilter.directorUserIdList,
            fileTypes: this.tableHeadFilter.fileTypes,
            company: this.tableHeadFilter.company,
            mainPart: this.tableHeadFilter.mainPart,
            mainPartName: this.tableHeadFilter.mainPartName,
            createdUserIdList: this.tableHeadFilter.createdUserIdList,
            contractStartAt: this.createdAt,
            contractEndAt: this.endAt,
            types:this.tableHeadFilter.types,
            signStatus:this.tableHeadFilter.signStatus,
            remark:this.tableHeadFilter.remark,
        }
        await getFinanceContractList(delNullProperty(obj)).then((data: any)=>{
            this.tableData = data.financeContractList
            this.total = data.allNum
            this.tableKey = Math.random()
            this.$nextTick(() => {
                if (this.$refs.multipleTable as HTMLFormElement) {
                    (this.$refs.multipleTable as HTMLFormElement).doLayout();
                    (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
                }
            });
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })
        // this.isReadonly = false
    }

    // 表头
    async gettHeaderByType() {
        const data: any = await gettHeaderByType(16)
        this.draggableList = data.headerUserList
        this.tableHead = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.getTableData()
    }

    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }

    // 设置表头
    async draggableEnd() {
        this.tableHeadPopoverShow = false
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({types: 16, headerIds: this.draggableList})
            this.$message.success('表头设置成功')
            this.gettHeaderByType()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    doCancel() {
        this.draggableListChange = JSON.parse(JSON.stringify(this.draggableList))
        this.tableHeadPopoverShow = false
    }

    handle() {
        document.body.click()
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData();
        }, 1000)
    }

    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData();
    }

    handleSelectionChange(row: any) {
        this.tableCheckedData = row
    }

    // 多选更换负责人
    async dialogConfirm() {
        if (!this.receiverUser) {
            this.$message.error('请选择负责人')
            return
        }
        (this.$refs['multipleTable'] as HTMLFormElement).clearSelection();
    }

    // 导出
    async exportExcel() {
        this.exportButtonDisabled = true
        const obj = {
            code: this.tableHeadFilter.code,
            status: this.tableHeadFilter.status,
            directorUserIdList: this.tableHeadFilter.directorUserIdList,
            fileTypes: this.tableHeadFilter.fileTypes,
            company: this.tableHeadFilter.company,
            mainPart: this.tableHeadFilter.mainPart,
            mainPartName: this.tableHeadFilter.mainPartName,
            createdUserIdList: this.tableHeadFilter.createdUserIdList,
            signStatus: this.tableHeadFilter.signStatus,
        }
        for (const key in obj) {
            if (obj[key].length === 0 || !obj[key]) {
                delete obj[key]
            }
        }

        financeArchiveExportData(obj)
            .then(()=>{
                this.$message.success('数据已转入后台导出, 请前往下载列表查看')
            })
            .finally(() => {
            this.exportButtonDisabled = false
        })
    }

    /*
    按钮权限验证
    */
    handleBtn(id: number) {
        return menuBtn(id)
    }

    // 新增
    openNewContract() {
        let url = ''
        if (this.newType === '2') {
            url = this.$route.matched[0].path + '/contractAdd' // 代理 / E签宝
        } else if (this.newType === '1') {
            url = this.$route.matched[0].path + '/contractAddAgent' // 学生 小程序
        } else {
            return
        }
        this.openPage(url)
        this.newType = ''
    }

    openPage(url: string) {
        const win = window.open(url, '_blank')
        this.dialogVisible = false
        const timer = setInterval(() => {
            if (win.closed) {
                clearInterval(timer)
                this.getTableData()
            }
        }, 500)
    }

    handleScan(row) {
        let win
        if (row.types === '小程序') {
            win = window.open(window.location.origin + '/financialCenter/contractStudentInfo?id=' + row.id + '&status=' + row.status)

        } else if (row.types === 'E签宝') {
            win = window.open(window.location.origin + '/financialCenter/contractInfo?id=' + row.id + '&status=' + row.status)
        }
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    /*
    * 编辑*/
    clickEditButton(row) {
        let win
        if (row.types === '小程序') {
            win = window.open(window.location.origin + this.$route.matched[0].path + '/contractAddAgent?contractId=' + row.id + '&status=' + row.status + '&isShow=' + row.isShow + '&type=编辑', '_blank')

        } else if (row.types === 'E签宝') {
            win = window.open(window.location.origin + this.$route.matched[0].path + '/contractAdd?contractId=' + row.id + '&status=' + row.status + '&isShow=' + row.isShow + '&type=编辑', '_blank')

        }
        const timer = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(timer)
            }
        }, 500)
    }

    /*
    *提交合同审批 */
    async setFinanceMarketCostStatus(row: any, action: string) {
        this.reviewId = row.id
        this.action = action
        if (action === '0') {
            this.clickCancelApproveDialogConfirmButton(row)
        } else {
            this.cancelApproveDialog = true
        }
    }

    clickCancelApproveDialogConfirmButton(row) {
        if (this.action === '0') {
            let win
            if (row.types === '小程序') {
                win = window.open(window.location.origin + this.$route.matched[0].path + '/contractAddAgent?contractId=' + row.id + '&status=' + row.status + '&isShow=' + row.isShow + '&type=编辑' + '&isUpdatedData=1', '_blank')

            } else if (row.types === 'E签宝') {
                win = window.open(window.location.origin + this.$route.matched[0].path + '/contractAdd?contractId=' + row.id + '&status=' + row.status + '&isShow=' + row.isShow + '&type=编辑' + '&isUpdatedData=1', '_blank')
            }

            const timer = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(timer)
                }
            }, 500)
            return
        } else {
            setFinanceContractStatus({
                id: Number(this.reviewId),
                action: this.action
            }).then(() => {
                this.$message.success(`成功${this.action === '0' ? '提交' : '撤回'}审批`)
                this.getTableData()
                this.cancelApproveDialog = false
            }).catch((err: Error) => {
                // 没有查到相关审批流程，暂时无法新建订单，请联系管理员设置审批流程
                if (err.message === '审批流报错') {
                    this.$message.error('此审批流程不适用您，请联系管理员')
                }
            })
        }
    }

    hendleDelClick(id) {
        this.delOrderId = id
        this.delOrderDialogShow = true
    }


    // 确定删除
    async delDialogConfirm() {
        await delFinanceContractById(this.delOrderId)
        this.$message.success('删除成功')
        this.delOrderDialogShow = false
        this.getTableData()
    }

    changeDirectorUserIdList(e) {
        this.tableHeadFilter.directorUserIdList = e.id
        this.page = 1
        this.getTableData()
    }

    changeCreatedUserIdList(e) {
        this.tableHeadFilter.createdUserIdList = e.id
        this.page = 1
        this.getTableData()
    }

    getExportData(keys: string = '') {
        this.exportButtonDisabled = true

        const obj = {
            code: this.tableHeadFilter.code,
            status: this.tableHeadFilter.status,
            directorUserIdList: this.tableHeadFilter.directorUserIdList,
            fileTypes: this.tableHeadFilter.fileTypes,
            company: this.tableHeadFilter.company,
            mainPart: this.tableHeadFilter.mainPart,
            mainPartName: this.tableHeadFilter.mainPartName,
            createdUserIdList: this.tableHeadFilter.createdUserIdList,
            contractStartAt: this.createdAt,
            contractEndAt: this.endAt,
            types:this.tableHeadFilter.types,
            signStatus:this.tableHeadFilter.signStatus,
            remark:this.tableHeadFilter.remark,
            keys,
        }
        financeContractExportData(delNullProperty(obj)).then(() => {
            this.exportButtonDisabled = false
            this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        }).catch(() => {
            this.exportButtonDisabled = false
        })

    }

}
